document.addEventListener('DOMContentLoaded', function () {
  (function ($) {
    $('body').on('click', '.card_link', function (e) {
      e.preventDefault();
      window.location.href = $(this).data("url");
    });

    $('body').on('click', '.grid__item .card input[type=\'radio\']', function () {
      if ($(this).is(':checked')) {
        $(this).parent().find('input').removeAttr('checked');
        $(this).parent().find('input').attr('checked', false);
        $(this).attr('checked', true);
      }
      var selectedOptionId = $(this).attr('data-value');
      var selectedOptionPrice = $(this).attr('data-price');
      var selectedOptionSku = $(this).attr('data-sku');
      var selectedOptionComparePrice = $(this).attr('data-compare_at_price');
      var selectedOptionInventory = $(this).attr('data-inventory');
      $(this).closest('.card-information').find('.updateSelectOptionValue').attr('value', selectedOptionId);
      $(this).closest('.card-information').find('.final-price.price-item').text(selectedOptionPrice);
      if (selectedOptionComparePrice.trim() != "") {
        $(this).closest('.card-information').find('.final-price.price-item').text(selectedOptionPrice);
        $(this).closest('.card-information').find('.original-price.price-item').css('display', 'inline');
        $(this).closest('.card-information').find('.original-price.price-item').text(selectedOptionComparePrice);
        $(this).closest('.card__information').find('.action').addClass('card_break');
      } else {
        if (window.onlyShowPoints && window.loyaltySkuPriceDict) {
          let pointsText = ''
          if (selectedOptionSku in window.loyaltySkuPriceDict) {
            pointsText = (parseFloat(window.loyaltySkuPriceDict[selectedOptionSku]) * 20).toLocaleString("en-US") + ' POINTS'
          }
          else {
            pointsText = (parseFloat(selectedOptionPrice.slice(1, selectedOptionPrice.length)) * 20).toLocaleString("en-US") + ' POINTS'
          }

          $(this).closest('.card-information').find('.final-price.price-item').text(pointsText);
        }
        else {
          $(this).closest('.card-information').find('.final-price.price-item').text(selectedOptionPrice);
        }
        $(this).closest('.card-information').find('.original-price.price-item').css('display', 'none');
        $(this).closest('.card__information').find('.action').removeClass('card_break');
      }
      if (selectedOptionInventory == 0 || selectedOptionInventory === 'false') {
        $(this).closest('.card__information').find('.quick-add__submit span').text('OUT OF STOCK');
        $(this).closest('.card__information').find('.action').addClass('sold_out');
        $(this).closest('.card__information').find('.quick-add__submit').attr('disabled', true);
      } else {
        $(this).closest('.card__information').find('.quick-add__submit span').text('ADD TO BAG');
        $(this).closest('.card__information').find('.action').removeClass('sold_out');
        $(this).closest('.card__information').find('.quick-add__submit').attr('disabled', false);
      }
    });
    $('body').ready(function () {
      $('.product-grid .grid__item').each((index, element) => {
        let inventory = $(element).find('.product-card-variant-option').eq(0).attr('data-inventory');
        let selectedOptionComparePrice = $(element).find('.product-card-variant-option').eq(0).attr('data-compare_at_price');
        let badgeTwo = $(element).find('.badge-two');
        if (inventory == 0) {
          $(element).find('.action').addClass('sold_out');
          $(element).find('.quick-add__submit span').text('OUT OF STOCK');
          $(element).find('.quick-add__submit').attr('disabled', true);
        }
        if (selectedOptionComparePrice.trim() != "") {
          $(element).find('.action').addClass('card_break');
        }
        if (badgeTwo != undefined && badgeTwo.length > 0) {
          checkOverflow(badgeTwo[0]) ? badgeTwo.addClass('badge-fix') : badgeTwo.removeClass('badge-fix');
        }
      });
    });
    $(window).resize(function () {
      $('.product-grid .grid__item').each((index, element) => {
        let badgeTwo = $(element).find('.badge-two');
        if (badgeTwo != undefined && badgeTwo.length > 0) {
          checkOverflow(badgeTwo[0]) ? badgeTwo.addClass('badge-fix') : badgeTwo.removeClass('badge-fix');
        }
      });
    });
    function checkOverflow(el) {
      var curOverflow = el.style.overflow;

      if (!curOverflow || curOverflow === "visible")
        el.style.overflow = "hidden";

      var isOverflowing = el.clientWidth < el.scrollWidth
        || el.clientHeight < el.scrollHeight;

      el.style.overflow = curOverflow;

      return isOverflowing;
    }
  })(jQuery);
});